import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { MyAnchor } from '../../../reusable/MyAnchor.jsx';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h2>{`Projects`}</h2>
    <ProjectCard title='Canasta.io' link='https://web.canasta.io' bg='linear-gradient(to right, #ef4f4f 0%, #ffcda3 100%)' mdxType="ProjectCard">
    Canasta.io is an online canasta simulator that allows you to play with your friends! It was
    built with React, Socket.io, and Express.
    <br />
    <br />
    <MyAnchor style={{
        color: '#ffcda3'
      }} href={'https://web.canasta.io'} mdxType="MyAnchor">
        Visit Site
    </MyAnchor>
    </ProjectCard>
    <ProjectCard title='Reposit' link='https://github.com/11grossmane/reposit' bg='linear-gradient(to right, #cd5d7d 0%, #a3d2ca 100%)' mdxType="ProjectCard">
    Reposit is a Github/Bitbucket command line interface optimized for OAuth.
    <br />
    <br />
    <MyAnchor style={{
        color: '#a3d2ca'
      }} href={'https://github.com/11grossmane/reposit'} mdxType="MyAnchor">
        View Package
    </MyAnchor>
    </ProjectCard>
    <ProjectCard title='Logging Middleware' bg='linear-gradient(to right, #939b62 0%, #ffc764 100%)' mdxType="ProjectCard">
    Gimme State is a fully customizeable logger for React and React-Native. Expo Redux Logger is a
    redux logger enhanced specificially for Expo/React-Native
    <br />
    <br />
    <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start'
      }}>
        <MyAnchor style={{
          color: '#ffc764',
          marginBottom: 5,
          fontSize: 15
        }} href={'https://github.com/11grossmane/gimme-state'} mdxType="MyAnchor">
            View Gimme State
        </MyAnchor>
        <MyAnchor style={{
          color: '#ffc764',
          fontSize: 15
        }} href={'https://github.com/11grossmane/expo-redux-logger'} mdxType="MyAnchor">
            View Expo Redux Logger
        </MyAnchor>
    </div>
    </ProjectCard>
    <ProjectCard title='Phondr' link='https://www.github.com/phondr/phondr' bg='linear-gradient(to right, #D4145A 0%, #FBB03B 100%)' mdxType="ProjectCard">
    Phondr is a level-up style dating app built with React Native, Express, GraphQL, and Postgres.
    My role encompassed both frontend and backend.
    <br />
    <br />
    <MyAnchor style={{
        color: '#FBB03B ',
        fontWeight: 'bold'
      }} onClick={e => e.stopPropagation()} href='https://github.com/Phondr/Phondr' mdxType="MyAnchor">
        View Github
    </MyAnchor>
    </ProjectCard>
    <ProjectCard title='Crptc' link='https://www.github.com/11grossmane/crptc' bg='linear-gradient(to right, #009245 0%, #bbd622 100%)' mdxType="ProjectCard">
    Crptc is a social app, built with React Native and Firestore, which encourages humor through
    limitation. **Built at 3 day Hackathon. I was the sole developer for this project.
    <br />
    <br />
    <MyAnchor style={{
        color: '#FCEE21',
        fontWeight: 'bold'
      }} onClick={e => e.stopPropagation()} href='https://github.com/11grossmane/Crptc' mdxType="MyAnchor">
        View Github
    </MyAnchor>
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      